var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"question"},[_vm._v(" "+_vm._s(_vm.question.libelle)+" --> "),_c('span',{staticClass:"strong anwser"},[_vm._v("["+_vm._s(_vm.response)+"] ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }